import * as React from "react"
import { Color } from "types/bootstrap"

import "./badge.scss"

type Placement =
	| "top"
	| "bottom"
	| "left"
	| "right"
	| "top-left"
	| "top-right"
	| "bottom-left"
	| "bottom-right"

interface Badge {
	color: Color
	textColor?: Color
	placement: Placement
	className?: string
}

const Badge: React.FC<Badge> = ({
	color,
	placement,
	textColor = "white",
	className = "",
	children,
}) => {
	return (
		<div
			className={`position-absolute bg-${color} text-${textColor} badge__${placement} ${className}`}
		>
			{children}
		</div>
	)
}

export default Badge
